import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row items-start space-y-8 sm:space-y-0 sm:space-x-8" }
const _hoisted_2 = { class: "w-full sm:w-1/2 rounded-3xl overflow-hidden shadow-xl shadow-indigo-700/30" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "w-full sm:w-1/2" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "inline-flex items-center space-x-2 text-gray-500" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = {
  key: 1,
  class: "mt-8"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("NFT Owner")
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Creators")
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Royalties")
const _hoisted_15 = ["textContent"]

import { computed, toRefs, watchEffect } from 'vue';
import { round } from 'lodash-es';
import {
  AccountPresenter, NftAccount, NftHolderAccount, NftMetadataAccount,
} from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: NftAccount | NftHolderAccount | NftMetadataAccount,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

const metadataAccount = computed(() => (account.value instanceof NftMetadataAccount ? account.value : account.value.metadataAccount));
const royalties = computed(() => round(metadataAccount.value.decodedData.data.sellerFeeBasisPoints / 100, 2));
const attributes = computed(() => account.value.metadata.attributes ?? []);
const creators = computed(() => metadataAccount.value.decodedData.data.creators ?? []);

const name = computed(() => {
  if (account.value.metadata.name) return account.value.metadata.name;
  if (metadataAccount.value.decodedData.data.name) return metadataAccount.value.decodedData.data.name;
  return 'Untitled NFT';
});

const collection = computed(() => {
  if (account.value.metadata.collection?.name) return account.value.metadata.collection.name;
  if (account.value.metadata.collection?.family) return account.value.metadata.collection.family;
  return 'Untitled NFT Collection';
});

watchEffect(async () => metadataAccount.value.nftOwner.load());

return (_ctx: any,_cache: any) => {
  const _component_icon_stack_simple = _resolveComponent("icon-stack-simple")!
  const _component_nft_attributes = _resolveComponent("nft-attributes")!
  const _component_base_label = _resolveComponent("base-label")!
  const _component_account_card_lazy = _resolveComponent("account-card-lazy")!
  const _component_nft_creators = _resolveComponent("nft-creators")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "w-full",
        src: _unref(account).metadata.image,
        alt: _unref(name)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", {
        class: "text-3xl font-semibold",
        textContent: _toDisplayString(_unref(name))
      }, null, 8, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_icon_stack_simple, { class: "w-5 h-5 text-gray-400" }),
        _createElementVNode("p", {
          textContent: _toDisplayString(_unref(collection))
        }, null, 8, _hoisted_7)
      ]),
      (_unref(account).metadata.description)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "text-gray-500 mt-2",
            textContent: _toDisplayString(_unref(account).metadata.description)
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_nft_attributes, {
        attributes: _unref(attributes),
        class: "mt-4"
      }, null, 8, ["attributes"]),
      (_unref(metadataAccount).nftOwner.successful)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_base_label, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_account_card_lazy, {
              address: _unref(metadataAccount).nftOwner.owner
            }, null, 8, ["address"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_nft_creators, { creators: _unref(creators) }, null, 8, ["creators"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _createElementVNode("p", {
          textContent: _toDisplayString(`${_unref(royalties)}%`)
        }, null, 8, _hoisted_15)
      ])
    ])
  ]))
}
}

})